
import Vue from 'vue';
import App from './App';
import axios from 'axios';
import VueRouter from 'vue-router';
import {router} from './router/index';


import iView from 'iview';
import 'iview/dist/styles/iview.css';  //iview 样式
import "babel-polyfill";

// Vue.use(axios);
Vue.prototype.axios = axios
Vue.use(VueRouter);
Vue.use(iView);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js